import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import BarChart from "../../../../components/charts/Bar";
import { useTranslation } from "react-i18next";
// import costData from "../../test/cost.json"
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { useSelector } from "react-redux";

export default function CostDetails() {
  const dashboardData = useSelector((state) => state.dashboard.jsonData);

  const costData = dashboardData?.cost_categories || [];

  const [selectedCategory, setSelectedCategory] = useState("");
  const { t } = useTranslation();
  const history = useHistory();

  const costDisplayData = selectedCategory
    ? costData
        .filter(
          (item) =>
            item.category === selectedCategory &&
            item.min !== undefined &&
            item.max !== undefined
        )
        .map(({ category, min, max }) => ({ category, min, max }))
    : costData
        .filter((item) => item.min !== undefined && item.max !== undefined)
        .map(({ category, min, max }) => ({ category, min, max }));

  const costDiscription = selectedCategory
    ? costData.find((item) => item.category === selectedCategory)?.[
        "justification"
      ]
    : "Select a threat to get description";

  function handleChangeCategory(event) {
    setSelectedCategory(event.target.value);
  }
  function handlGoBack() {
    history.goBack();
  }

  return (
    <Box
      sx={{
        marginBottom: { xs: "25%" },
      }}
    >
      <Button
        sx={{
          background: "#78c3ae",
          borderRadius: 4,
          fontSize: "16px",
          marginLeft: { xs: "8px", sm: "5px" }, // Remove marginLeft on mobile
          alignSelf: "flex-start",

          "&:hover": {
            backgroundColor: "#60dbb9",
          },
        }}
        onClick={handlGoBack}
      >
        <ArrowBackIcon sx={{ color: "white" }} />
      </Button>
      <Typography sx={{ textAlign: "center", fontSize: "40px" }}>
        Cost categories
      </Typography>
      {/* Cost Category */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 2, sm: 4 },
          mt: 4,
          px: { xs: 1, sm: 2 },
        }}
      >
        <Box
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            p: { xs: 2, sm: 3 },
            bgcolor: "background.paper",
            width: { xs: "90%", sm: "90%", md: "90%" },
            flex: 1,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            minHeight: 180,
          }}
        >
          <FormControl fullWidth>
            <InputLabel
              id="threat-select-label"
              sx={{ fontSize: { xs: "1rem", sm: "1.2rem" } }}
            >
              Category Type
            </InputLabel>
            <Select
              labelId="threat-select-label"
              id="threat-select"
              value={selectedCategory}
              label="Threat Type"
              onChange={handleChangeCategory}
              sx={{
                height: { xs: "52px", sm: "64px" },
                fontSize: { xs: "1rem", sm: "1.25rem" },
              }}
            >
              <MenuItem
                value=""
                sx={{ fontSize: { xs: "0.9rem", sm: "1.1rem" } }}
              >
                <em>All Categorys</em>
              </MenuItem>
              {costData.map((cat, index) => (
                <MenuItem
                  key={index}
                  value={cat?.category}
                  sx={{ fontSize: { xs: "0.9rem", sm: "1.1rem" } }}
                >
                  {t(cat?.category)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "center",
          alignItems: "flex-start",
          gap: { xs: 2, sm: 4 },
          mt: 4,
          px: { xs: 1, sm: 2 },
        }}
      >
        {/* BarChart Box (DoughnutPieChart remains unchanged) */}
        <Box
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            p: { xs: 2, sm: 3 },
            bgcolor: "background.paper",
            width: { xs: "90%", sm: "45%", md: "40%" },
            minHeight: "450px",
            height: "auto",
            textAlign: "center",
          }}
        >
          <BarChart
            data={costDisplayData}
            xKey="category" // Explicitly set xKey to match the key in your data
            xLabel="Category" // Label for the x-axis
            yLabel="Cost ($)" // Label for the y-axis
            title="Cost categories" // Title of the chart
          />
        </Box>

        {/* Description Box */}

        <Box
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            p: { xs: 2, sm: 3 },
            bgcolor: "background.paper",
            width: { xs: "90%", sm: "45%", md: "40%" },
            minHeight: "450px",
            height: "auto",
            textAlign: "start",
          }}
        >
          <Typography>{costDiscription}</Typography>
        </Box>
      </Box>
    </Box>
  );
}
